import { configureStore } from '@reduxjs/toolkit'
import authReducer from './AuthStore'
import appReducer from './AppStore'
import notesReduser from './NotesStore'
import actionAlerts from './ActionAlertsStore'

export const store = configureStore({
    reducer: {
        app: appReducer,
        auth: authReducer,        
        notes: notesReduser,
        actionAlerts: actionAlerts
    },
})

export type RootState = ReturnType<typeof store.getState>